import { IconButton, SvgIcon } from '@mui/material';
import React, { useContext } from 'react';
import getMuiIcon from '../../../utils/getMuiIcon';
import { borderRadius, boxShadows, palette } from '../../../assets/styles/themes/tokens';
import { aiAssistantContext } from '../../../state/AIAssistantContextProvider';

const AIAssistantToggler = () => {
  const { isAssistantOpen, toggleAssistant } = useContext(aiAssistantContext);

  return <IconButton
    data-testid='ai-assistant-toggler'
    onClick={toggleAssistant}
    sx={{
      backgroundColor: isAssistantOpen ? palette.primary.dark : palette.primary.main,
      borderRadius: borderRadius.full,
      boxShadow: boxShadows.elevation3,
      '&:hover': {
        backgroundColor: palette.primary.dark,
      }
    }}>
    <SvgIcon
      sx={{ 
        width: 24,
        height: 24,
        color: palette.common.white,
      }}
      viewBox='0 0 24 24'
      component={getMuiIcon('magicPen')}
    /> 
  </IconButton>;
};

export default AIAssistantToggler;
